
import { initDexie, type DexieInstance } from '@/idb/dexie'

const dexieInstance: {db: DexieInstance | null} = { db: null }

export const idb = {
  async getDb(){
    return dexieInstance.db as DexieInstance;
  },
  async deleteAllData(){
    if(!dexieInstance.db) return;
    await dexieInstance.db.delete();
  },
  async initializeDb(){
    if(dexieInstance.db){
      if(dexieInstance.db.isOpen()){
        return;
      }
    }
    dexieInstance.db = await initDexie() as DexieInstance;
  },
}